const items = {
  "labels.week.0": "星期日",
  "labels.week.1": "星期一",
  "labels.week.2": "星期二",
  "labels.week.3": "星期三",
  "labels.week.4": "星期四",
  "labels.week.5": "星期五",
  "labels.week.6": "星期六",
  "labels.collaborators": "协作者",
  "labels.collaboration": "协作",
  "labels.link": "链接",
  "labels.upload": "上传",
  "labels.first-term": "第一个术语",
  "labels.sign-in": "登录",
  "labels.first-wbw": "第一个逐词解析",
  "labels.first-translation": "第一个译文",
  "labels.first-course": "第一个课程",
  "labels.updated-at": "更新于",
  "labels.created-at": "创建于",
  "labels.recent-scan": "最近打开",
  "labels.icp": "ICP:",
  "labels.no.login": "尚未登录",
  "labels.page.number.type.M": "缅文版页码",
  "labels.page.number.type.T": "泰文版页码",
  "labels.page.number.type.P": "PTS版页码",
  "labels.page.number.type.V": "印度内观研究所版页码",
  "labels.page.number.type.O": "其他页码",
  "labels.page.number.type.para": "缅文段落",
  "labels.curr.paragraph.only": "仅显示此段",
  "labels.curr.paragraph.open": "在新标签页打开",
  "labels.curr.paragraph.copy.tpl": "复制句子编号",
  "labels.curr.paragraph.quote.link.tpl": "引用链接模版",
  "labels.curr.paragraph.copy.quote.link.tpl": "复制引用模版",
  "labels.input": "请输入",
  "labels.selected": "已经选择",
  "labels.page.number.type.c": "章节名称",
  "labels.loading": "载入中",
  "labels.empty": "无内容",
  "labels.curr.paragraph.cart.tpl": "添加到手推车",
  "labels.dict.pass.0": "内文查询",
  "labels.dict.pass.1": "直接查",
  "labels.dict.pass.2": "查词典源型",
  "labels.dict.pass.3": "查衍生",
  "labels.dict.pass.4": "查二次衍生",
  "labels.software.edition.guest": "未注册",
  "labels.software.edition.basic": "基础版",
  "labels.software.edition.pro": "增强版",
  "labels.table-of-content": "目录",
  "labels.this-studio": "此工作室",
  "labels.feedback": "网站功能报错与建议",
  "labels.email.sign-up.subject": "欢迎注册wikipāli",
  "labels.sign-up": "注册",
  "labels.done": "完成",
  "labels.tag.list": "标签列表",
  "labels.error.401": "未登录",
  "labels.error.403": "没有权限",
  "labels.error.404": "没有找到指定的资源",
  "labels.error.429": "请求过于频繁",
  "labels.error.500": "服务器内部错误",
  "labels.task": "任务",
  "labels.task.hall": "任务大厅",
  "labels.task.mine": "我的任务",
  "labels.task.my.project": "我的项目",
  "labels.all": "全部",
  "labels.mention.me": "提及我的",
  "labels.in.progressing": "进行中",
  "labels.closed": "已关闭",
  "labels.workflow": "工作流",
  "labels.task.status.pending": "待定",
  "labels.task.status.published": "已发布",
  "labels.task.status.running": "进行中",
  "labels.task.status.done": "已完成",
  "labels.task.status.restarted": "已重启",
  "labels.task.status.requested_restart": "已请求重启",
  "labels.task.status.closed": "已关闭",
  "labels.task.status.canceled": "已取消",
  "labels.task.status.expired": "已过期",
  "labels.task.status.queue": "排队中",
  "labels.task.status.stop": "停止",
  "labels.task.status.quit": "放弃",
  "labels.task.status.pause": "暂停",
  "labels.filter": "过滤器",
  "labels.participants": "参与者",
  "labels.task.category": "任务类型",
  "labels.task.category.translate": "翻译",
  "labels.task.category.vocabulary": "词汇表",
  "labels.task.category.team": "术语",
  "labels.task.category.review": "审稿",
  "labels.task.category.proofread": "润色",
  "labels.task.category.suggest": "修改建议",
  "labels.ai-assistant": "人工智能助手",
  "labels.filters.includes": "包含",
  "labels.filters.not-includes": "不包含",
  "labels.filters.equal": "等于",
  "labels.filters.not-equal": "不等于",
  "labels.filters.null": "为空",
  "labels.filters.not-null": "不为空",
  "labels.filters.and": "全部条件",
  "labels.filters.or": "任一条件",
  "labels.task.workflows": "工作流",
  "labels.milestone": "里程碑",
  "labels.flowchart": "流程图",
  "labels.table": "表格",
  "labels.list": "列表",
  "labels.shared": "共享",
  "labels.community": "社区",
  "labels.task.prev.executors": "前置执行者",
};

export default items;
